import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classNames from "classnames";
import { getRehydratableName, getClassNameFactory } from "../../utilities";
import contextTypes from "./contextTypes";
import Panel from "./components/Panel";
import Tab from "./components/Tab";
import TabList from "./components/TabList";

var Tabs = /*#__PURE__*/function (_Component) {
  _inherits(Tabs, _Component);

  var _super = _createSuper(Tabs);

  function Tabs(props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this, props);
    _this.getClassName = getClassNameFactory(Tabs.displayName);
    var tabs = Tabs.getTabs(props.children);
    _this.state = {
      currentOpenPanel: props.defaultTab || tabs[0] && tabs[0].relatedId || null,
      tabs: tabs
    };
    _this.updateFromHash = _this.updateFromHash.bind(_assertThisInitialized(_this));
    _this.handleTabClick = _this.handleTabClick.bind(_assertThisInitialized(_this));
    _this.handleTabListKeyDown = _this.handleTabListKeyDown.bind(_assertThisInitialized(_this));
    _this.setOpenPanel = _this.setOpenPanel.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tabs, [{
    key: "getChildContext",
    value: function getChildContext() {
      // We carefully considered the use of context here. In the case of Tabs,
      // it simplifies the logic for rehydration, reduces coupling between
      // components, and eliminates hidden props. React have suggested that this
      // API may change in the future; if and when that happens, we need to
      // update our implementation to match.
      return {
        currentOpenPanel: this.state.currentOpenPanel
      };
    }
  }, {
    key: "setOpenPanel",
    value: function setOpenPanel(panelId) {
      var _this$state = this.state,
          tabs = _this$state.tabs,
          currentOpenPanel = _this$state.currentOpenPanel;
      var handleTabChange = this.props.handleTabChange;
      this.setState({
        currentOpenPanel: panelId
      });
      Tabs.setLocationHash(panelId);
      var tabIndex = tabs.findIndex(function (tab) {
        return tab.relatedId === panelId;
      });
      var tab = tabs[tabIndex];

      if (handleTabChange) {
        handleTabChange(panelId, currentOpenPanel);
      }

      this.props.analytics("Tab navigation", "Click ".concat(tabIndex + 1), tab.title, panelId);
    }
  }, {
    key: "handleTabListKeyDown",
    value: function handleTabListKeyDown(e) {
      var _this2 = this;

      var currentOpenPanelIndex = this.state.tabs.findIndex(function (tab) {
        return tab.relatedId === _this2.state.currentOpenPanel;
      });
      var desktopViewportWidth = 768;
      var direction = getComputedStyle(this.ref).direction;
      var nextKey = direction === "ltr" ? "ArrowRight" : "ArrowLeft";
      var previousKey = direction === "ltr" ? "ArrowLeft" : "ArrowRight";
      var focusPanelKey = "ArrowDown";

      if (this.props.layoutVariant === "verticalAtDesktop" && window.innerWidth >= desktopViewportWidth) {
        nextKey = "ArrowDown";
        previousKey = "ArrowUp";
        focusPanelKey = direction === "ltr" ? "ArrowRight" : "ArrowLeft";
      }

      if ([nextKey, previousKey].includes(e.key)) {
        var newOpenPanel;

        if (e.key === previousKey) {
          newOpenPanel = this.state.tabs[Math.max(0, currentOpenPanelIndex - 1)].relatedId;
        } else {
          newOpenPanel = this.state.tabs[Math.min(this.state.tabs.length - 1, currentOpenPanelIndex + 1)].relatedId;
        }

        this.setOpenPanel(newOpenPanel);
      } else if (e.key === focusPanelKey) {
        // See https://inclusive-components.design/tabbed-interfaces/#aproblemreadingpanels
        this.ref.querySelector("#".concat(this.state.currentOpenPanel)).focus();
      }
    }
  }, {
    key: "handleTabClick",
    value: function handleTabClick(e, relatedId) {
      e.preventDefault();
      this.setOpenPanel(relatedId);
    } // This function returns the size of the header, if the header is 'above' the given
    // position in the whole document. If the header is below, return 0.

  }, {
    key: "updateFromHash",
    value: function updateFromHash() {
      var locationHash = Tabs.getLocationHash();

      if (locationHash && this.state.tabs.map(function (tab) {
        return tab.relatedId;
      }).includes(locationHash)) {
        this.setOpenPanel(locationHash);
        var elementPosition = this.ref.getBoundingClientRect().top + window.pageYOffset; // wait until after window does its usual scroll to anchor

        setTimeout(function () {
          window.scrollTo(0, elementPosition - Tabs.calculateHeaderOffset(elementPosition));
        }, 0);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateFromHash();

      if (window) {
        window.addEventListener("hashchange", this.updateFromHash);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProp) {
      if (prevProp !== this.props) {
        var newState = {
          tabs: Tabs.getTabs(this.props.children)
        };

        if (newState.tabs.length === 0) {
          newState.currentOpenPanel = null;
        } else if (!newState.tabs.map(function (tab) {
          return tab.relatedId;
        }).includes(this.state.currentOpenPanel)) {
          // The previously open tab no longer exists. Open either the default tab,
          // or the first tab if no default is set.
          newState.currentOpenPanel = this.props.defaultTab || newState.tabs[0].relatedId;
        }

        this.setState(newState);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (window) {
        window.removeEventListener("hashchange", this.updateFromHash);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          defaultTab = _this$props.defaultTab,
          layoutVariant = _this$props.layoutVariant;
      return /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          modifiers: classNames(layoutVariant)
        }),
        "data-default-tab": defaultTab,
        "data-layout-variant": layoutVariant,
        "data-rehydratable": getRehydratableName(Tabs.displayName),
        "data-rehydratable-children-selector": ".".concat(this.getClassName({
          descendantName: "panel"
        })),
        ref: function ref(_ref) {
          return _this3.ref = _ref;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "list"
        })
      }, /*#__PURE__*/React.createElement(TabList, {
        layoutVariant: layoutVariant,
        horizontalTabsActions: !this.props.layoutVariant && this.props.horizontalTabsActions
      }, this.state.tabs.map(function (tab) {
        return /*#__PURE__*/React.createElement(Tab, _extends({}, tab, {
          key: tab.relatedId,
          layoutVariant: layoutVariant,
          onClick: _this3.handleTabClick,
          onKeyDown: _this3.props.handleKeyDownPress || _this3.handleTabListKeyDown,
          selected: tab.relatedId === _this3.state.currentOpenPanel
        }));
      }))), /*#__PURE__*/React.createElement("div", {
        className: this.getClassName({
          descendantName: "panel"
        })
      }, children));
    }
  }], [{
    key: "getTabs",
    value: function getTabs(children) {
      var tabs = [];
      React.Children.forEach(children, function (child) {
        if ((child === null || child === void 0 ? void 0 : child.type) === Panel) {
          tabs.push(_objectSpread({
            title: child.props.tabTitle,
            relatedId: child.props.id
          }, child.props.dataAttribute && {
            dataAttribute: child.props.dataAttribute
          }));
        } else if ((child === null || child === void 0 ? void 0 : child.type) === React.Fragment) {
          tabs.push.apply(tabs, _toConsumableArray(Tabs.getTabs(child.props.children)));
        }
      });
      return tabs;
    }
  }, {
    key: "calculateHeaderOffset",
    value: function calculateHeaderOffset(position) {
      var headers = document.querySelectorAll("[class$=--sticky]");

      for (var i = 0; i < headers.length; i++) {
        var header = headers[i]; // check if the header is at the top of the page

        if (header.getBoundingClientRect().top + window.pageYOffset <= position) {
          return header.offsetHeight;
        }
      }

      return 0;
    }
  }]);

  return Tabs;
}(Component);

_defineProperty(Tabs, "displayName", "Tabs");

_defineProperty(Tabs, "childContextTypes", contextTypes);

_defineProperty(Tabs, "propTypes", {
  /**
   * An analytics function, accepting category, action, and label as arguments.
   */
  analytics: PropTypes.func,

  /**
   * The content of the tabs. These should be of type `Tabs.Picker` or `Tabs.Panel`.
   */
  children: PropTypes.node,

  /**
   * The ID of the default tab to open. This will be used if no ID was found in the URL that exists in this set of tabs. If none is specified, the first tab panel will be used as the default.
   */
  defaultTab: PropTypes.string,

  /**
   * If changing to different tab pass in optional function.  This passes two parameters, one for id of tabbed clicked, and one for id of current tab.
   */
  handleTabChange: PropTypes.func,

  /**
   * Optional modifier to switch layout variants
   */
  layoutVariant: PropTypes.oneOf(["verticalAtDesktop"]),

  /**
   * Prop to render right-side components inside horizontal tabs row
   */
  horizontalTabsActions: PropTypes.node,

  /**
   * Prop to render handleKeyDown event
   */
  handleKeyDownPress: PropTypes.func
});

_defineProperty(Tabs, "defaultProps", {
  analytics: function analytics() {}
});

_defineProperty(Tabs, "getLocationHash", function () {
  if (window && window.location && window.location.hash) {
    return window.location.hash.substr(1);
  }

  return null;
});

_defineProperty(Tabs, "setLocationHash", function (hash) {
  if (history && history.pushState) {
    history.replaceState(null, "", "#".concat(hash));
  }
});

Tabs.Panel = Panel;
export default Tabs;